/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import * as o from '../output/output_ast';

const CORE = '@angular/core';

export class Identifiers {
  /* Methods */
  static NEW_METHOD = 'factory';
  static TRANSFORM_METHOD = 'transform';
  static PATCH_DEPS = 'patchedDeps';

  /* Instructions */
  static namespaceHTML: o.ExternalReference = {name: 'ÉµnamespaceHTML', moduleName: CORE};

  static namespaceMathML: o.ExternalReference = {name: 'ÉµnamespaceMathML', moduleName: CORE};

  static namespaceSVG: o.ExternalReference = {name: 'ÉµnamespaceSVG', moduleName: CORE};

  static element: o.ExternalReference = {name: 'Éµelement', moduleName: CORE};

  static elementStart: o.ExternalReference = {name: 'ÉµelementStart', moduleName: CORE};

  static elementEnd: o.ExternalReference = {name: 'ÉµelementEnd', moduleName: CORE};

  static elementProperty: o.ExternalReference = {name: 'ÉµelementProperty', moduleName: CORE};

  static elementAttribute: o.ExternalReference = {name: 'ÉµelementAttribute', moduleName: CORE};

  static elementClassProp: o.ExternalReference = {name: 'ÉµelementClassProp', moduleName: CORE};

  static elementContainerStart:
      o.ExternalReference = {name: 'ÉµelementContainerStart', moduleName: CORE};

  static elementContainerEnd:
      o.ExternalReference = {name: 'ÉµelementContainerEnd', moduleName: CORE};

  static elementStyling: o.ExternalReference = {name: 'ÉµelementStyling', moduleName: CORE};

  static elementStylingMap: o.ExternalReference = {name: 'ÉµelementStylingMap', moduleName: CORE};

  static elementStyleProp: o.ExternalReference = {name: 'ÉµelementStyleProp', moduleName: CORE};

  static elementStylingApply:
      o.ExternalReference = {name: 'ÉµelementStylingApply', moduleName: CORE};

  static containerCreate: o.ExternalReference = {name: 'Éµcontainer', moduleName: CORE};

  static nextContext: o.ExternalReference = {name: 'ÉµnextContext', moduleName: CORE};

  static templateCreate: o.ExternalReference = {name: 'Éµtemplate', moduleName: CORE};

  static text: o.ExternalReference = {name: 'Éµtext', moduleName: CORE};

  static textBinding: o.ExternalReference = {name: 'ÉµtextBinding', moduleName: CORE};

  static bind: o.ExternalReference = {name: 'Éµbind', moduleName: CORE};

  static enableBindings: o.ExternalReference = {name: 'ÉµenableBindings', moduleName: CORE};

  static disableBindings: o.ExternalReference = {name: 'ÉµdisableBindings', moduleName: CORE};

  static getCurrentView: o.ExternalReference = {name: 'ÉµgetCurrentView', moduleName: CORE};

  static restoreView: o.ExternalReference = {name: 'ÉµrestoreView', moduleName: CORE};

  static interpolation1: o.ExternalReference = {name: 'Éµinterpolation1', moduleName: CORE};
  static interpolation2: o.ExternalReference = {name: 'Éµinterpolation2', moduleName: CORE};
  static interpolation3: o.ExternalReference = {name: 'Éµinterpolation3', moduleName: CORE};
  static interpolation4: o.ExternalReference = {name: 'Éµinterpolation4', moduleName: CORE};
  static interpolation5: o.ExternalReference = {name: 'Éµinterpolation5', moduleName: CORE};
  static interpolation6: o.ExternalReference = {name: 'Éµinterpolation6', moduleName: CORE};
  static interpolation7: o.ExternalReference = {name: 'Éµinterpolation7', moduleName: CORE};
  static interpolation8: o.ExternalReference = {name: 'Éµinterpolation8', moduleName: CORE};
  static interpolationV: o.ExternalReference = {name: 'ÉµinterpolationV', moduleName: CORE};

  static pureFunction0: o.ExternalReference = {name: 'ÉµpureFunction0', moduleName: CORE};
  static pureFunction1: o.ExternalReference = {name: 'ÉµpureFunction1', moduleName: CORE};
  static pureFunction2: o.ExternalReference = {name: 'ÉµpureFunction2', moduleName: CORE};
  static pureFunction3: o.ExternalReference = {name: 'ÉµpureFunction3', moduleName: CORE};
  static pureFunction4: o.ExternalReference = {name: 'ÉµpureFunction4', moduleName: CORE};
  static pureFunction5: o.ExternalReference = {name: 'ÉµpureFunction5', moduleName: CORE};
  static pureFunction6: o.ExternalReference = {name: 'ÉµpureFunction6', moduleName: CORE};
  static pureFunction7: o.ExternalReference = {name: 'ÉµpureFunction7', moduleName: CORE};
  static pureFunction8: o.ExternalReference = {name: 'ÉµpureFunction8', moduleName: CORE};
  static pureFunctionV: o.ExternalReference = {name: 'ÉµpureFunctionV', moduleName: CORE};

  static pipeBind1: o.ExternalReference = {name: 'ÉµpipeBind1', moduleName: CORE};
  static pipeBind2: o.ExternalReference = {name: 'ÉµpipeBind2', moduleName: CORE};
  static pipeBind3: o.ExternalReference = {name: 'ÉµpipeBind3', moduleName: CORE};
  static pipeBind4: o.ExternalReference = {name: 'ÉµpipeBind4', moduleName: CORE};
  static pipeBindV: o.ExternalReference = {name: 'ÉµpipeBindV', moduleName: CORE};

  static i18n: o.ExternalReference = {name: 'Éµi18n', moduleName: CORE};
  static i18nAttributes: o.ExternalReference = {name: 'Éµi18nAttributes', moduleName: CORE};
  static i18nExp: o.ExternalReference = {name: 'Éµi18nExp', moduleName: CORE};
  static i18nStart: o.ExternalReference = {name: 'Éµi18nStart', moduleName: CORE};
  static i18nEnd: o.ExternalReference = {name: 'Éµi18nEnd', moduleName: CORE};
  static i18nApply: o.ExternalReference = {name: 'Éµi18nApply', moduleName: CORE};
  static i18nPostprocess: o.ExternalReference = {name: 'Éµi18nPostprocess', moduleName: CORE};

  static load: o.ExternalReference = {name: 'Éµload', moduleName: CORE};
  static loadQueryList: o.ExternalReference = {name: 'ÉµloadQueryList', moduleName: CORE};

  static pipe: o.ExternalReference = {name: 'Éµpipe', moduleName: CORE};

  static projection: o.ExternalReference = {name: 'Éµprojection', moduleName: CORE};
  static projectionDef: o.ExternalReference = {name: 'ÉµprojectionDef', moduleName: CORE};

  static reference: o.ExternalReference = {name: 'Éµreference', moduleName: CORE};

  static inject: o.ExternalReference = {name: 'inject', moduleName: CORE};

  static injectAttribute: o.ExternalReference = {name: 'ÉµinjectAttribute', moduleName: CORE};

  static directiveInject: o.ExternalReference = {name: 'ÉµdirectiveInject', moduleName: CORE};

  static templateRefExtractor:
      o.ExternalReference = {name: 'ÉµtemplateRefExtractor', moduleName: CORE};

  static defineBase: o.ExternalReference = {name: 'ÉµdefineBase', moduleName: CORE};

  static BaseDef: o.ExternalReference = {
    name: 'ÉµBaseDef',
    moduleName: CORE,
  };

  static defineComponent: o.ExternalReference = {name: 'ÉµdefineComponent', moduleName: CORE};

  static ComponentDefWithMeta: o.ExternalReference = {
    name: 'ÉµComponentDefWithMeta',
    moduleName: CORE,
  };

  static defineDirective: o.ExternalReference = {
    name: 'ÉµdefineDirective',
    moduleName: CORE,
  };

  static DirectiveDefWithMeta: o.ExternalReference = {
    name: 'ÉµDirectiveDefWithMeta',
    moduleName: CORE,
  };

  static InjectorDef: o.ExternalReference = {
    name: 'ÉµInjectorDef',
    moduleName: CORE,
  };

  static defineInjector: o.ExternalReference = {
    name: 'defineInjector',
    moduleName: CORE,
  };

  static NgModuleDefWithMeta: o.ExternalReference = {
    name: 'ÉµNgModuleDefWithMeta',
    moduleName: CORE,
  };

  static defineNgModule: o.ExternalReference = {name: 'ÉµdefineNgModule', moduleName: CORE};

  static PipeDefWithMeta: o.ExternalReference = {name: 'ÉµPipeDefWithMeta', moduleName: CORE};

  static definePipe: o.ExternalReference = {name: 'ÉµdefinePipe', moduleName: CORE};

  static query: o.ExternalReference = {name: 'Éµquery', moduleName: CORE};
  static queryRefresh: o.ExternalReference = {name: 'ÉµqueryRefresh', moduleName: CORE};
  static registerContentQuery:
      o.ExternalReference = {name: 'ÉµregisterContentQuery', moduleName: CORE};

  static NgOnChangesFeature: o.ExternalReference = {name: 'ÉµNgOnChangesFeature', moduleName: CORE};

  static InheritDefinitionFeature:
      o.ExternalReference = {name: 'ÉµInheritDefinitionFeature', moduleName: CORE};

  static ProvidersFeature: o.ExternalReference = {name: 'ÉµProvidersFeature', moduleName: CORE};

  static listener: o.ExternalReference = {name: 'Éµlistener', moduleName: CORE};

  static getFactoryOf: o.ExternalReference = {
    name: 'ÉµgetFactoryOf',
    moduleName: CORE,
  };

  static getInheritedFactory: o.ExternalReference = {
    name: 'ÉµgetInheritedFactory',
    moduleName: CORE,
  };

  // sanitization-related functions
  static sanitizeHtml: o.ExternalReference = {name: 'ÉµsanitizeHtml', moduleName: CORE};
  static sanitizeStyle: o.ExternalReference = {name: 'ÉµsanitizeStyle', moduleName: CORE};
  static defaultStyleSanitizer:
      o.ExternalReference = {name: 'ÉµdefaultStyleSanitizer', moduleName: CORE};
  static sanitizeResourceUrl:
      o.ExternalReference = {name: 'ÉµsanitizeResourceUrl', moduleName: CORE};
  static sanitizeScript: o.ExternalReference = {name: 'ÉµsanitizeScript', moduleName: CORE};
  static sanitizeUrl: o.ExternalReference = {name: 'ÉµsanitizeUrl', moduleName: CORE};
}
